import type { FormInstance } from 'antd';

/**
 * Bidirectional sync between Player Identity (defaultPlayerType + isWicketKeeper)
 * and Base Stats role field.
 *
 * Player Identity → Base Stats:
 *   defaultPlayerType 0 (Batsman) + isWicketKeeper true  → role 3 (WK)
 *   defaultPlayerType 0 (Batsman) + isWicketKeeper false → role 0 (Batter)
 *   defaultPlayerType 1 (Bowler)                         → role 1 (Bowler)
 *   defaultPlayerType 2 (All-Rounder)                    → role 2 (All-Rounder)
 *
 * Base Stats → Player Identity:
 *   role 0 (Batter)       → defaultPlayerType 0, isWicketKeeper false
 *   role 1 (Bowler)       → defaultPlayerType 1
 *   role 2 (All-Rounder)  → defaultPlayerType 2
 *   role 3 (WK)           → defaultPlayerType 0, isWicketKeeper true
 */
export function syncPlayerTypeAndRole(form: FormInstance, changed: Record<string, unknown>): void {
  if ('defaultPlayerType' in changed || 'isWicketKeeper' in changed) {
    const playerType =
      (changed.defaultPlayerType as number) ?? (form.getFieldValue('defaultPlayerType') as number);
    const isWk =
      (changed.isWicketKeeper as boolean) ?? (form.getFieldValue('isWicketKeeper') as boolean);

    let statsRole: number;
    if (playerType === 0 && isWk) {
      statsRole = 3; // WK
    } else if (playerType === 0) {
      statsRole = 0; // Batter
    } else if (playerType === 1) {
      statsRole = 1; // Bowler
    } else {
      statsRole = 2; // All-Rounder
    }
    form.setFieldsValue({ baseStats_role: statsRole });
  }

  if ('baseStats_role' in changed) {
    const statsRole = changed.baseStats_role as number;
    if (statsRole === 3) {
      form.setFieldsValue({ defaultPlayerType: 0, isWicketKeeper: true });
    } else if (statsRole === 0) {
      form.setFieldsValue({ defaultPlayerType: 0, isWicketKeeper: false });
    } else if (statsRole === 1) {
      form.setFieldsValue({ defaultPlayerType: 1 });
    } else if (statsRole === 2) {
      form.setFieldsValue({ defaultPlayerType: 2 });
    }
  }
}
